<template>
  <div id="paper-root" style="max-width: 1200px;margin: 0 auto;">
    <a-layout theme="light" :class="'paper-style-'+userPaperInfo.paperStyle">
      <a-layout v-show="examStatus==1">
        <a-drawer
          title="题目列表"
          placement="bottom"
          :closable="false"
          :visible="drawerStatus"
          @close="drawerStatus=false"
        >
          <a-row>
            <a-col :span="10">答题进度：{{paperQuestion.length - undoCount}} / {{paperQuestion.length}}</a-col>
            <a-col :span="14">
              <span>已答&nbsp;</span><a-tag color="blue">&nbsp;</a-tag>
              <span v-if="userPaperInfo.paperStyle==2">当前&nbsp;</span><a-tag v-if="userPaperInfo.paperStyle==2" color="orange">&nbsp;</a-tag>
              <span>未答&nbsp;</span><a-tag>&nbsp;</a-tag>
            </a-col>
          </a-row>
            <div v-for="(q, i) in paperQuestion" :key="i" style="float: left;margin-top: 8px;">
             
                <a-tag :color="(userPaperInfo.paperStyle==2 && i == currentQuestionIndex) ? 'orange' : isWriteAnswer(i) ? 'blue' : ''" @click="jumpQuestion(i),drawerStatus=false">{{ i + 1 }}</a-tag>
            </div>
        </a-drawer>
        <!-- 答题区域 -->
        <div class="headerBox">
          <p class="djs_box" > 倒计时：{{ remainTimeText }}</p>
          <div>
            <div class="jj_button dtk_button" @click.stop="requestSubmitPaper">
              <i class="iconfont">&#xe615;</i><span>交卷</span>
            </div>
            <div class="dtk_button" @click.stop="drawerStatus = true" v-if="_isMobile()">
              <i class="iconfont">&#xe614;</i><span>答题卡</span>   
            </div>
          </div>
        </div>
        
        <a-layout-content >
          <div class="answerSheet" v-if="!_isMobile()">
              <div class="answerSheetHeader"><span class="left">题目列表</span><span class="right">答题进度：{{ paperQuestion.length - undoCount }} / {{ paperQuestion.length}}</span></div>
              <div style="margin: 8px 0;">
                  <span>已答&nbsp;</span><a-tag color="blue">&nbsp;</a-tag>
                  <span>当前&nbsp;</span><a-tag color="orange">&nbsp;</a-tag>
                  <span>未答&nbsp;</span><a-tag>&nbsp;</a-tag>
              </div>
              <div v-for="(q, i) in paperQuestion" :key="i" style="float: left;margin-top: 8px;">
                  <a-tag
                      :color="(userPaperInfo.paperStyle == 2 && i == currentQuestionIndex) ? 'orange' : isWriteAnswer(i) ? 'blue' : ''"
                      @click="jumpQuestion(i), drawerStatus = false" style="cursor: pointer;">{{ i + 1 }}</a-tag>
              </div>
          </div>
          <!-- 单页样式 -->
          <div v-if="userPaperInfo.paperStyle==1">
            单页试卷暂不支持
          </div>
          <!-- 一页一题样式 -->
          <div v-if="userPaperInfo.paperStyle==2" class="paper-content" :bordered="false" :style="{'width': !_isMobile() ? '70%' : '','float': !_isMobile() ? 'right' : ''}">
            <div class="paper-content-item" v-show="qi == currentQuestionIndex" v-for="(q, qi) in paperQuestion" :key="qi">
              <a-row >
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <a-card class="stem-card" :bordered="false" :headStyle="{'background':'#c8c8c84a'}" :bodyStyle="{'background':'#c8c8c84a'}"> 
                    <span slot="title">
                      <span>{{getQuestionTypeText(q.questionType)}}</span>
                    </span>
                    <div class="question-stem">
                     <p style="float: left;">{{ qi+1 }}、</p><div style="float: left;" v-html="q.questionStem" :id="'question-stem-' + q.id"></div>
                    </div>
                  </a-card>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <a-card class="answer-card" title="" :bordered="false" :headStyle="{'background':'#c8c8c84a'}" :bodyStyle="{'background':'#c8c8c84a'}" v-if="paperAnswer.length > 0">
                    <!-- 单选 -->
                    <a-radio-group class="question-radio" :disabled="examStatus != 1" v-if="q.questionType == 1"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html="o.item"></div>
                          </div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group class="question-checkbox" :disabled="examStatus != 1" v-if="q.questionType == 2"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <div class="checkbox-content">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html="o.item"></div>
                          </div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group class="question-switch" :disabled="examStatus != 1" v-if="q.questionType == 3"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(0) }}</span>
                          <span>{{$t('exam.right')}}</span>
                        </div>
                      </a-radio>
                      <a-radio value="false">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(1) }}</span>
                          <span>{{$t('exam.wrong')}}</span>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <div class="question-fill-wrap" v-if="q.questionType == 4">
                      <a-input
                        class="question-fill"
                        :readOnly="examStatus!=1"
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                        :addonBefore="'第' + oi + '空'"
                        :placeholder="'请填写第' + oi + '空回答'"
                      />
                    </div>
                    <!-- 主观题 -->
                    <div class="question-read" v-if="q.questionType == 5">
                      <a-textarea :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                    </div>
                    <!-- 阅读分析 -->
                    <div class="question-multi" v-if="q.questionType == 6">
                      <hr>
                      <div v-for="(o, oi) in q.questionOptions" :key="oi" class="sub-question">
                        <span>({{(oi+1)}}) </span>
                        <div v-html="o.stem"></div>
                        <a-radio-group class="question-radio" :disabled="examStatus != 1" v-model="paperAnswer[qi]['myAnswer'][oi]">
                          <a-radio v-for="(oo, ooi) in o.options" :key="ooi" :value="ooi">
                            <div class="radio-content">
                              <span class="question-letter">{{ index2letter(ooi) }}
                              </span>
                              <div class="question-options-content">
                                <div class="option" v-html="oo.item"></div>
                              </div>
                            </div>
                          </a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                    <!-- 控制条 -->
                    <div class="question-opt-btn">
                      <!-- <a-button @click="reportQuestion(q)" style="" type="link">反馈问题</a-button> -->
                      <div class="switch-btn">
                        <a-button class="prevBtn" type="primary" @click="prevQuestion" v-show="currentQuestionIndex != 0">上一题</a-button>
                        <a-button class="nextBtn" type="primary" @click="nextQuestion" v-show="currentQuestionIndex != paperQuestion.length-1">下一题</a-button>
                      </div>
                    </div>
                  </a-card>
                </a-col>
              </a-row>
            </div>
          
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import  { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'

export default {
  name: 'Examine',
  mixins: [mixinDevice,jumpMixins,examMixins],
  components: {
    JModal,
    Voice
  },
  data() {
    return {
      heightOffset: 0,
      paperId: '',
      departId: '',
      paperDeptId: '',
      eventApplyId: '', //报名ID
      eventApplyCategory: '', //报名赛项
      userPaperList: [],
      loadingUserPaperList: false,
      userPaperInfo: {}, //用户答题卡信息
      paperQuestion: [], //已经过转换的题目信息
      questionSections: {},//题目分类信息
      paperAnswer: [], // 答题卡信息
      undoCount: 0, //未作答题目数量
      isCurrentQuestionChange: false, // 当前题目是否已修改
      userPaperId: '', // 答题卡ID
      paperDescVisible: false, //试卷介绍是否可见
      selectPaperVisible: false, //选择试卷modal
      cameraList: [],
      currentCamera: '',
      mediaRecorder: null,
      screenRecorder: null,
      duration: 0, //用时
      remaining: 0, //剩余时间
      remainTimeText: '',
      examStatus: -1, //考试状态 -1预览 0已结束 1正在考试
      canRequestQustion: true, //是否可以请求题目
      canSave: true, //防止保存试卷高频点击
      canSubmit: true, //防止提交试卷高频点击
      isRequestMyPaperQuestion: false, //是否已请求试卷
      isSaved: false, //答题是否已保存
      drawerStatus:false,   //答题卡
    }
  },
  watch:{
    paperAnswer:{
      handler(newValue, oldValue){
        if(this.paperQuestion){
          console.log("修改了题目", this.currentQuestionIndex, newValue, oldValue);
          this.isSaved = false
          this.isCurrentQuestionChange = true
          let undoCount = 0
          this.paperQuestion[this.currentQuestionIndex]['isSubmit'] = true
          for (let i = 0; i < this.paperQuestion.length; i++) {
            if (!this.isWriteAnswer(i)) {undoCount++}
          }
          this.undoCount = undoCount
        }
      },
      deep: true
    },
    currentQuestionIndex(newValue, oldValue){
      console.log("chanage quetsion", newValue, oldValue);
      if(this.isCurrentQuestionChange && this.isWriteAnswer(oldValue)){
        this.submitOneAnswer(oldValue)
      }
      this.isCurrentQuestionChange = false
    }
  },
  created() {
    let that = this
    // this.getCode()
    console.log(this.$route.query , '参数')
    this.requestMyPaperQuestionInfo(this.$route.query) //获取试卷列表
    //拦截未登录
    if (!this.$store.getters.userInfo) {
      this.$info({
        title: that.$t('sys.notLogin'),
        content: that.$t('exam.pleaseToLogin'),
        okText: that.$t('sys.toLogin'),
        onOk() {
          that.toLogin()
        },
      });
      // return
    }else{
      console.log("userInfo", this.$store.getters.userInfo);
    }

    //防止页面重复打开
    if(Vue.ls.get("examing") != null){
      alert("请不要同时打开多个考试页面")
      // window.location.href = "/";
      return
    }else{
      Vue.ls.set("examing", Math.random(), 11000)
      window.examingFlag = setInterval(function(){
        Vue.ls.set("examing", Math.random(), 11000)
      }, 10000)
    }

    if (this.$route.query.id) {
      this.paperId = this.$route.query.id
    }
    if (this.$route.query.departId) {
      this.departId = this.$route.query.departId
    }
    if(this.$route.query.eaid){
      this.eventApplyId = this.$route.query.eaid
    }
    this.eventApplyCategory = this.$route.query.category
    if (this.$route.query.userPaperId) {
      //传入答题卡ID，继续考试
      this.userPaperId = this.$route.query.userPaperId
      this.requestMyPaperQuestionInfo({})
    } 
   
  },
  mounted() {
    var that = this

    //是否切换了页面
    document.addEventListener("visibilitychange", function(e){
    });
    //拦截未登录
    if (!this.$store.getters.userInfo) { return }
    //刷新页面拦截
    window.onbeforeunload = function (e) {
      if(that.examStatus == 1){
        e.returnValue = that.$t('exam.ensureLeave')
      }
      if(window.examingFlag){
        Vue.ls.remove("examing")
        window.clearInterval(window.examingFlag)
      }
    }
    //监听代码提交事件
    document.addEventListener('submit', function (e) {
      that.onCodeSubmit(e.detail)
    })
    document.addEventListener('submitOJ', function (e) {
      that.onOJCodeSubmit(e.detail)
    })
    //监听页面失去焦点
    window.onblur = function () {
      if (!that.editorVisible) {
        window.jumptime = new Date().getTime()
        window.jumping = setTimeout(function () {
          that.jumpOutLog()
        }, 30000)//30秒后记录日志
      }
    }
    //监听编辑器失去焦点
    document.addEventListener('onEditorBlur', function (e) {
      if (that.editorVisible) {
        that.jumpOutLog()
      }
    })
    //回到考试，清除正在跳出页面的状态
    window.onfocus = function () {
      window.jumptime = 0;
      clearTimeout(window.jumping)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.examStatus != 1) {
      next()
      return;
    }
    let that = this
    let ensureLeave = that.$t('exam.ensureLeave')
    let savePaperNow = that.$t('exam.savePaperNow')
    this.$confirm({
      title: this.$t('sys.notice'),
      okText:'保存进度',
      cancelText:'继续考试',
      content: <div>
        <p>{ensureLeave}</p>
        <h2>{savePaperNow} </h2>
      </div>,
      onOk() {
        that.savePaper(1).then(() => {
          that.finishedExam()
          next()
        })
      },
      onCancel() {
        // next()
      },
    });
  },
  //离开页面
  beforeDestroy() {
    if(window.examingFlag){
      Vue.ls.remove("examing")
      window.clearInterval(window.examingFlag)
    }
    this.finishedExam()
  },
  methods: {
    upload2Qiniu: upload2Qiniu,
    dataURLtoBlob: dataURLtoBlob,
    continueExam(userPaperId){

    },
    //请求答题卡和题目
    requestMyPaperQuestionInfo(paperModal) {
      if (!this.canRequestQustion) {
        this.$message.warning(this.$t('sys.clickTooFast'))
        return
      }
      
      if(this.isRequestMyPaperQuestion){return;}
      this.canRequestQustion = false
      // getAction(`/teaching/teachingPaper/getMyPaperQuestion?paperDeptId=${paperModal.paperDeptId}&paperId=${paperModal.paperId}&departId=${paperModal.departId}&userPaperId=${this.userPaperId}&eventApplyId=${this.eventApplyId}`).then((res) => {
        getAction('/teaching/teachingPaper/getMyPaperQuestion', {
          paperDeptId: paperModal.paperDeptId,
          paperId: paperModal.paperId,
          departId: paperModal.departId,
          userPaperId: this.userPaperId,
          eventApplyId: this.eventApplyId
        }).then((res) => {
        if (res.success && res.result != null) { 
          this.isRequestMyPaperQuestion = true
          this.parseUserPaperInfo(res.result.userPaper)
          this.parseQuestion(res.result.question)
          // this.fullScreen()
        } else {
          this.$message.error(res.message)
          this.userPaperId = ''
          this.changeURLStatic("userPaperId", "")
        }
        this.canRequestQustion = true
      })
    },
    nextQuestion(){
      window.document.dispatchEvent(new CustomEvent('viocePause'));
      if(this.currentQuestionIndex == this.paperQuestion.length-1){
        return
      }
      this.currentQuestionIndex++
    },
    prevQuestion(){
      window.document.dispatchEvent(new CustomEvent('viocePause'));
      if(this.currentQuestionIndex == 0){
        return
      }
      this.currentQuestionIndex--
    },


    //留存打点日志
    contentLog(content, url){
      if(this.examStatus == 1){
        postAction(`/teaching/teachingUserPaperLog/examLog`,
        {
          userPaperId: this.userPaperId,
          logType: 6,
          logContent: content,
          fileUrl: url
        }).then(res => {
        })
      }
    },
    //浏览器检测
    checkBroswer() {
      if(this.checkChromeVersion() >= 94){
        this.deviceTestResult.browser = true
      }else{
        this.deviceTestResult.browser = false
      }
      return this.deviceTestResult.browser
    },
    //解析用户答卷信息
    parseUserPaperInfo(info) {
      if (!info) {return}
      this.userPaperInfo = info
      this.paperId = info.paperId
      this.userPaperId = info.userPaperId
      this.departId = info.departId
      this.paperDeptId = info.paperDeptId
      this.selectPaperVisible = false
      this.examStatus = (info == null || info.userPaperStatus == 0) ? 1 : 0
      // 一页一题则关闭自动保存
      if(this.userPaperInfo.paperStyle == 2){
        this.savePaperInterval = 0
      }
      this.changeURLStatic("userPaperId", this.userPaperId)
      //启动倒计时
      this.startCountDown()
      // 计算header
      let that = this
    },
    //解析题目
    parseQuestion(question) {
      let that = this
      this.paperQuestion = []
      this.paperAnswer = []
      let currentSection = null;
      let preLoadEditorQuestion = null; // 预加载编辑器的题目
      for (let qi in question) {
        let q = question[qi]
        //解析题目分类
        if (q.questionSection) {
          currentSection = qi
          this.questionSections[qi] = {
            text: q.questionSection,
            count: 0,
            score: 0
          }
        }
        if (currentSection != null) {
          this.questionSections[currentSection].count += 1;
          this.questionSections[currentSection].score += q.questionScore;
        }
        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
        }
        q.voiceText = this.getQuestionVoice(q)
        this.paperQuestion.push(q)
        if (q.myAnswer != null || q.myAnswerFile != null) {
          this.paperAnswer.push({ qid: q.questionId, myAnswer: this.parseAnswer(q.questionType, q.myAnswer), myAnswerFile: q.myAnswerFile })
        } else {
          if (q.questionType == 2 || q.questionType == 4 || q.questionType == 6) {
            //填空题 多选题 阅读题结构
            this.paperAnswer.push({ qid: q.questionId, myAnswer: [] })
          } else {
            this.paperAnswer.push({ qid: q.questionId, myAnswer: '' })
          }
        }
        //渲染填空题dom
        if (q.questionType == 4) {
          this.renderGapFillingStemDom(q, qi)
        }
        if(q.questionType == 7){
          preLoadEditorQuestion = q
        }
      }
      //自动选择到未作答的题目
      for(let i in this.paperAnswer){
        if(!this.isWriteAnswer(i)){
          this.currentQuestionIndex = i
          break
        }
      }
    },
    
    //倒计时
    startCountDown() {
      if(this.examStatus != 1 || !this.userPaperInfo || window.countDownInterval){return}

      window.startExamTime = new Date().getTime(); // 答题开始时间
      if (this.userPaperInfo.duration) {this.duration = this.userPaperInfo.duration}
      if (this.userPaperInfo.timeLimit == 0) { //不限时
        this.remaining = -1
      } else if (this.userPaperInfo.timeLimit > 0 && this.userPaperInfo.duration) {
        //继续做题，减去已消耗时间
        this.remaining = this.userPaperInfo.timeLimit * 60 - this.userPaperInfo.duration
        if (this.remaining <= 0) { //虽然正在考试，但是已超时
          this.examStatus = 0
          this.onTimeout()
        }
      } else {
        //新开始做题
        this.remaining = this.userPaperInfo.timeLimit * 60
      }
      let that = this
      window.countDownInterval = setInterval(function () {
        if(that.examStatus !=1) return
        let now = new Date().getTime()
        let elapsedTime = now - window.startExamTime // 经过时间
        that.duration = that.userPaperInfo.duration + (elapsedTime/1000)
        that.remaining = that.userPaperInfo.timeLimit * 60 - that.duration
        that.remainTimeText = that.formatTime(that.remaining)
        if (that.remaining == 300) {
          that.notify(that.$t('exam.remaining5min'))
        } else if (that.remaining == 60) {
          that.notify(that.$t('exam.remaining1min'))
        } 
        if (that.remaining <= 0) {
          that.onTimeout()
        }
      }, 1000)

      //自动保存试卷
      if(this.savePaperInterval > 0){
        setInterval(function(){
          if(that.examStatus == 1 && !that.isSaved){
            that.savePaper(0)
          }
        }, this.savePaperInterval)
      }
    },
    
    //到达考试时间
    onTimeout() {
      this.examStatus = 0
      clearInterval(window.countDownInterval)
      clearInterval(window.autoSaveCodeInterval)
      this.$message.warn(this.$t('exam.examFinished'))
      //强制提交
      this.submitPaper(0)
    },
    //保存试卷
    savePaper(manual) {
      let that = this
      if(this.isSaved){
        this.$message.success(this.$t('sys.saveSuccess'))
        return
      }
      if (!this.canSave) {
        this.$message.warning(this.$t('sys.clickTooFast'))
        return
      } else{
        this.canSave = false
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=0&manual=${manual}&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          if(res.result){
            this.userPaperId = res.result
          }
          this.$message.success(this.$t('sys.saveSuccess'))
        } else {
          this.$message.warn(res.message)
        }
        that.canSave = true
        that.isSaved = true
      }).catch((err)=>{
        console.log(err);
        this.$message.warn(this.$t('sys.networkError'))
        that.canSave = true
        that.isSaved = true
      })
    },
    //点击交卷
    requestSubmitPaper() {
      let that = this
      let undoCountStr = this.$t('exam.undoCount', {undoCount: this.undoCount})
      let submitPaperNow = this.$t('exam.submitPaperNow')
      this.$confirm({
        title: that.$t('exam.submitPaper'),
        content: <div>
          {submitPaperNow}
          <h2>{this.undoCount > 0 ? <h3 style="color:red">{undoCountStr}</h3> : ''}</h2>
        </div>,
        onOk() {
          that.submitPaper(1)
        },
        okType: 'danger',
        okText: that.$t('exam.submitPaper'),
        onCancel() {},
      });
    },
    //提交试卷
    submitPaper(manual) {
      let that = this
      if (!this.canSubmit) {
        this.$message.warning(this.$t('sys.clickTooFase'))
        return
      } else {
        this.canSubmit = false
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=1&manual=${manual}&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          this.userPaperId = res.result
          this.notify(this.$t('exam.submitSuccess'))
          this.finishedExam()
          this.$router.back()
        } else {
          this.canSubmit = true
          that.isSaved = true
          this.$message.warn(res.message)
        }
      }).catch((err)=>{
        this.$message.warn(this.$t('sys.networkError'))
        this.canSubmit = true
        that.isSaved = true
      })
    },
    // 提交一个题目
    submitOneAnswer(questionIndex){
      console.log("submitOneAnswer", this.paperAnswer[questionIndex]);
      let questionId = this.paperAnswer[questionIndex]['qid']
      postActionWithParam(
        `/teaching/teachingQuestion/submitAnswer`,
        this.paperAnswer[questionIndex], {
          questionId: questionId,
          paperId: this.paperId,
          userPaperId: this.userPaperId,
          departId: this.departId,
        }
      ).then((res) => {
        if (res.success) {
          // this.$message.success('已保存答题进度')
        } else {
          this.$message.warn(res.message)
        }
      }).catch((err)=>{
        this.$message.warn(this.$t('sys.networkError'))
      })
    },
    //考试结束
    finishedExam(){
      this.examStatus = 0
      clearInterval(window.countDownInterval)
      clearInterval(window.autoSaveCodeInterval)
    
      window.onbeforeunload = null;
      window.onblur = null
      window.mediaStreamTrack && window.mediaStreamTrack.stop();
      this.mediaRecorder && this.mediaRecorder.stop();
      this.mediaRecorder && this.mediaRecorder.stream && this.mediaRecorder.stream.stop();
      this.screenRecorder && this.screenRecorder.stop();
      this.screenRecorder && this.screenRecorder.stream && this.screenRecorder.stream.stop();
    },
    //页面跳出记录
    jumpOutLog() {
      let that = this
      if (this.examStatus == 1) {
        postAction(`/teaching/teachingUserPaperLog/examLog`, {
          userPaperId: this.userPaperId,
          logType: 1,
        }).then(res => {
          this.$destroyAll();
          if (this.userPaperInfo.jumpOutLimit > -1 && res.result > this.userPaperInfo.jumpOutLimit) {
            //中断考试
            this.examStatus = 0
            clearInterval(window.countDownInterval)
            clearInterval(window.autoSaveCodeInterval)
            this.$error({
              title: that.$t('sys.warning'),
              content: that.$t('exam.jumpoutBreak'),
            });
          } else if (this.userPaperInfo.jumpOutLimit > -1) {
            this.$error({
              title: that.$t('sys.warning'),
              content: that.$t('exam.jumpoutNotice'),
            });
          }
        })
      }
    },
    reportQuestion(question){
      console.log(question);
      this.show53kf()
    },
    download(url){
      window.open(url + "?t="+new Date().getTime())
    },
  },
}
</script>
<style lang="less" scoped>
@import url('../../assets/exam.less');
</style>